<template>
  <div>
    <b-row no-gutters>
      <b-col>
        <b-form-input
          v-model="longlat"
          :placeholder="format ? 'Lat, Long' : 'Long, Lat'"
          @keyup.enter="centerMap"
          style="text-align: center"
        />
      </b-col>
      <b-col
        @click="swapLongLat()"
        title="Swap Format"
        style="cursor: pointer"
        align-self="center"
        cols="2"
      >
        <fa
          :icon="['fas', 'exchange-alt']"
          style="display: block; margin: auto"
          size="lg"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import {fromLonLat, transform} from 'ol/proj'

export default {
  name: 'MMP_CoordinateInput',
  props: ['map'],
  data() {
    return {
      longlat: '',
      vectorSource: null,
      format: false
    }
  },
  methods: {
    centerMap() {
      if (!this.longlat.includes(',')) {
        alert('Please Enter Proper Format')
        return
      }

      let coords = this.longlat.split(',')
      let x, y
      if (this.format) {
        y = parseFloat(coords[0])
        x = parseFloat(coords[1])
      } else {
        x = parseFloat(coords[0])
        y = parseFloat(coords[1])
      }

      if (x > 180 || x < -180) {
        alert('Please Enter Valid Longitude')
        return
      } else if (y > 90 || y < -90) {
        alert('Please Enter Valid Latitude')
        return
      }

      let newCenter = new transform([x, y], 'EPSG:4326', 'EPSG:3857')
      this.map.getView().animate({zoom: 18}, {center: newCenter})

      this.vectorSource.clear()
      let geoMarker = new Feature({
        type: 'geoMarker',
        geometry: new Point(new fromLonLat([x, y]))
      })
      this.vectorSource.addFeature(geoMarker)
    },
    initVectorLayer() {
      this.vectorSource = new VectorSource({})
      let vectorLayer = new VectorLayer({
        source: this.vectorSource
      })
      vectorLayer.setZIndex(999999999)
      this.$emit('getVectorlayer', vectorLayer)
    },
    swapLongLat() {
      this.format = !this.format
      if (this.longlat.includes(',')) {
        let newFormat = this.longlat.split(',')
        this.longlat = newFormat[1].trim() + ', ' + newFormat[0].trim()
      }
    }
  },
  mounted() {
    if (sessionStorage.token) {
      this.initVectorLayer()
    } else {
      this.$router.push({name: 'Login'})
    }
  }
}
</script>
